import { render, staticRenderFns } from "./ModalAccountantApprove.vue?vue&type=template&id=263c6fe2"
import script from "./ModalAccountantApprove.vue?vue&type=script&lang=js"
export * from "./ModalAccountantApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports